import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  FaPlane, 
  FaPhone, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaFacebook, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedin,
  FaWhatsapp 
} from 'react-icons/fa';
import logo from '../assets/logo.jpg'; // Update the path to your logo


const Footer = () => {
  const quickLinks = [
    { name: 'Flight Booking', path: '/flight-booking' },
    { name: 'Hotel Booking', path: '/hotel-booking' },
    { name: 'Apartment Booking', path: '/apartment-booking' },
    { name: 'Airport Pickup', path: '/airport-pickup' },
    { name: 'Car Rental', path: '/car-rental' },
  ];

  const socialLinks = [
    { icon: FaFacebook, href: '#', color: 'hover:text-blue-600' },
    { icon: FaTwitter, href: '#', color: 'hover:text-blue-400' },
    { icon: FaInstagram, href: '#', color: 'hover:text-pink-600' },
    { icon: FaLinkedin, href: '#', color: 'hover:text-blue-700' },
    { icon: FaWhatsapp, href: '#', color: 'hover:text-green-500' },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      {/* Pre-footer CTA Section */}
      <div className="gradient-green py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h3 className="text-3xl font-bold text-white mb-4">
              Ready to Plan Your Nigerian Adventure?
            </h3>
            <p className="text-xl text-green-100 mb-8 max-w-2xl mx-auto">
              Let Yowa Travels handle all your travel needs. From flights to accommodations, 
              we make your journey seamless and memorable.
            </p>
            <Link 
              to="/flight-booking"
              className="inline-flex items-center space-x-2 bg-white text-green-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-green-50 transition-all duration-300 transform hover:scale-105 shadow-xl"
            >
              <FaPlane />
              <span>Start Booking Now</span>
            </Link>
          </motion.div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="space-y-6">
            <div className="flex items-start space-x-4">
  <img 
    src={logo} // Make sure this path points to your actual logo
    alt="Yowa Travels Logo"
    className="w-12 h-12 rounded-full object-cover"
  />
  <div>
    <h3 className="text-2xl font-bold">Yowa Travels</h3>
    <p className="text-green-400 font-medium">Your Journey, Our Priority</p>
    <p className="text-sm text-gray-400 mt-1 italic">Subsidiary of Javern Group</p>
  </div>
</div>

              <p className="text-gray-300 leading-relaxed">
                Nigeria's premier travel booking platform. We specialize in flights, 
                accommodations, and ground transportation across Nigeria, making your 
                travel dreams a reality.
              </p>
              <div className="flex space-x-4">
                {socialLinks.map((social, index) => {
                  const IconComponent = social.icon;
                  return (
                    <a
                      key={index}
                      href={social.href}
                      className={`w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center transition-all duration-300 ${social.color} hover:scale-110`}
                    >
                      <IconComponent size={18} />
                    </a>
                  );
                })}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-bold mb-6 text-green-400">Our Services</h4>
              <ul className="space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-gray-300 hover:text-green-400 transition-colors duration-300 flex items-center space-x-2"
                    >
                      <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                      <span>{link.name}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-bold mb-6 text-green-400">Contact Us</h4>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <FaMapMarkerAlt className="text-green-500 mt-1 flex-shrink-0" />
                  <div className="text-gray-300">
                    <p>Central Business District</p>
                    <p>Abuja, Nigeria</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <FaPhone className="text-green-500 flex-shrink-0" />
                  <p className="text-gray-300">+234 (0) 800 YOWA (9692)</p>
                </div>
                <div className="flex items-center space-x-3">
                  <FaWhatsapp className="text-green-500 flex-shrink-0" />
                  <p className="text-gray-300">+234 (0) 901 234 5678</p>
                </div>
                <div className="flex items-center space-x-3">
                  <FaEnvelope className="text-green-500 flex-shrink-0" />
                  <p className="text-gray-300">support@yowa.com</p>
                </div>
              </div>
            </div>

            {/* Business Hours */}
            <div>
              <h4 className="text-lg font-bold mb-6 text-green-400">Business Hours</h4>
              <div className="space-y-3 text-gray-300">
                <div className="flex justify-between">
                  <span>Monday - Friday</span>
                  <span>8:00 AM - 8:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Saturday</span>
                  <span>9:00 AM - 6:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Sunday</span>
                  <span>10:00 AM - 4:00 PM</span>
                </div>
                <div className="mt-4 p-3 bg-green-900 rounded-lg">
                  <p className="text-green-300 text-sm">
                    <strong>24/7 Emergency Support</strong><br />
                    For flight changes & urgent assistance
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-800 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 Yowa Travels. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-green-400 text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-green-400 text-sm transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-green-400 text-sm transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;